export default [{
	path: '/building',
	component: resolve => require(['@/views/building'], resolve),
	meta: {
		title: '建设中'
	}
}]


// WEBPACK FOOTER //
// ./src/router/modules/building.js